<template>
  <div class="debroglie-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$λ = h / p$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>粒子动量 p</label>
            <span class="val">{{ momentum.toFixed(1) }} <small>kg·m/s</small></span>
          </div>
          <div class="hud-item orange">
            <label>导引波长 λ</label>
            <span class="val">{{ wavelength.toFixed(2) }} <small>nm</small></span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 450 240" preserveAspectRatio="xMidYMid meet">
          <!-- 粒子运动轨迹 (Particle Path as Probability Wave) -->
          <path :d="wavePath" fill="none" stroke="#0ea5e9" stroke-width="2" />
          
          <!-- 实时波包演示 (Wave Packet / Envelope) -->
          <g v-for="i in 5" :key="i">
             <circle :cx="particleX - i*10" :cy="120 + Math.sin((particleX - i*10)*k)*15" r="3" fill="#fbbf24" :opacity="1 - i*0.2" />
          </g>

          <!-- 粒子实体 (Entity) -->
          <circle :cx="particleX" :cy="120 + Math.sin(particleX*k)*15" r="8" fill="#fbbf24" filter="url(#glow-db)" />
          
          <text x="225" y="215" text-anchor="middle" fill="#334155" font-size="10">左右调节速度，观察波动频率的变化</text>
          
          <defs>
             <filter id="glow-db"><feGaussianBlur stdDeviation="4" result="blur"/><feComposite in="SourceGraphic" in2="blur" operator="over"/></filter>
          </defs>
        </svg>

        <div class="physics-caption">
           规律：粒子的动量 $p$ 越大，其对应的物质波波长 $\lambda$ 就越短。宏观物体虽也有波动，但因数值极小而无法察觉。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="flex-row items-center gap-6">
              <div class="flex-1">
                 <label class="s-label">调节电子速度 (动量) p：{{ momentum }}</label>
                 <el-slider v-model="momentum" :min="1" :max="50" size="small"></el-slider>
              </div>
              <div class="btn-group">
                 <el-button type="info" size="mini" @click="momentum = 5">慢速 (长波)</el-button>
                 <el-button size="mini" @click="momentum = 45">极速 (超短波)</el-button>
              </div>
           </div>
        </div>
        
        <!-- 原子专用高对比度卡片加固 -->
        <div class="discovery-card-discovery-tir" v-latex>
           <div class="icon-wrap"><i class="el-icon-odometer"></i></div>
           <div class="text-content">
             <p><strong>实战物理/电子显微镜：</strong>德布罗伊物质波让显微镜进入了“原子时代”。<strong>解惑：</strong>为什么电子显微镜比光学显微镜更清晰？<strong>观察：</strong>调节滑块。你会发现当电子加速时，它的**波长变窄、频率变高**。由于这种极短的波长，电子可以绕过更小的原子间隙，从而拍出传统光线根本无法企及的微观高清图像。
             </p>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'DeBroglieMatterWaveProViz',
  data() {
    return {
      momentum: 10,
      particleX: 50,
      time: 0
    }
  },
  computed: {
    wavelength() { return 500 / this.momentum; },
    k() { return (2 * Math.PI) / this.wavelength; },
    wavePath() {
       let d = `M 0,120 `;
       for(let x=0; x<450; x+=2) {
          d += `L ${x},${120 + Math.sin(x * this.k)*15}`;
       }
       return d;
    }
  },
  mounted() { this.animate(); },
  methods: {
    animate() {
       this.particleX += 2;
       if (this.particleX > 450) this.particleX = 0;
       this.animFrame = requestAnimationFrame(this.animate);
    }
  },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.debroglie-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
